import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitialInterviewRoutingModule } from './initial-interview-routing.module';
import { InitialInterviewContainerComponent } from "./initial-interview-container/initial-interview-container.component";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule, MatLabel} from "@angular/material/form-field";
import { AngularSvgIconModule } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { InitialInterviewSplashPageComponent } from "./initial-interview-splash-page/initial-interview-splash-page.component";
import { InitialInterviewQuestionsComponent } from "./initial-interview-questions/initial-interview-questions.component";
import { TalentHappyPathHeaderComponent } from "../shared/components/talent-happy-path-header/talent-happy-path-header.component";
import { TalentHappyPathFooterComponent } from "../shared/components/talent-happy-path-footer/talent-happy-path-footer.component";
import { TalentHappyPathAuthService } from "../shared/service/talent-happy-path-auth.service";
import { TalentHappyPathAuthResolver } from "../shared/service/talent-happy-path-auth.resolver";
import { InitialInterviewApplicationSubmitPageComponent } from "./initial-interview-application-submit-page/initial-interview-application-submit-page.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { InitialInterviewNoQuestionsPageComponent } from "./initial-interview-no-questions-page/initial-interview-no-questions-page.component";
import { InitialInterviewHangTightPageComponent } from "./initial-interview-hang-tight-page/initial-interview-hang-tight-page.component";
import { LogoutConfirmationModalComponent } from "../shared/components/logout-confirmation-modal/logout-confirmation-modal.component";
import { InitialInterviewWelcomeBackPageComponent } from './initial-interview-welcome-back-page/initial-interview-welcome-back-page.component';
import { MatDividerModule } from "@angular/material/divider";
import { PayTransparencyComponent } from './pay-transparency/pay-transparency.component';
import { ConfirmationModalComponent } from "../shared/components/confirmation-modal/confirmation-modal.component";
import {
    PayTransparencyResponseChartComponent
} from "./pay-transparency/pay-transparency-response-chart/pay-transparency-response-chart.component";
import { VideoInterviewLandingPageComponent } from "./video-interview/video-interview-landing-page/video-interview-landing-page.component";
import { VideoInterviewPageComponent } from "./video-interview/video-interview-page/video-interview-page.component";

@NgModule({
  declarations: [
    InitialInterviewContainerComponent,
    InitialInterviewQuestionsComponent,
    TalentHappyPathHeaderComponent,
    TalentHappyPathFooterComponent,
    InitialInterviewWelcomeBackPageComponent,
    PayTransparencyComponent
  ],
  exports: [TalentHappyPathHeaderComponent, TalentHappyPathFooterComponent],
  imports: [
    MatButton,
    MatFormFieldModule,
    MatButtonModule,
    MatLabel,
    MatInputModule,
    AngularSvgIconModule.forRoot(),
    CommonModule,
    InitialInterviewRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatRadioModule,
    MatChipsModule,
    CommonModule,
    MatIconModule,
    MatDatepickerModule,
    InitialInterviewSplashPageComponent,
    InitialInterviewApplicationSubmitPageComponent,
    MatProgressSpinner,
    InitialInterviewNoQuestionsPageComponent,
    InitialInterviewHangTightPageComponent,
    LogoutConfirmationModalComponent,
    MatDividerModule,
    ConfirmationModalComponent,
    LogoutConfirmationModalComponent,
    PayTransparencyResponseChartComponent,
    VideoInterviewLandingPageComponent,
    VideoInterviewPageComponent
  ],
  providers: [TalentHappyPathAuthService, TalentHappyPathAuthResolver]
})
export class InitialInterviewModule {}
